import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VDPbEditor = () => {
  const LANGS = ["En", "Ar", "Ku"];

  const [form, setForm] = useState({
    TitleEn: "",
    TitleAr: "",
    TitleKu: "",

    DescEn: "",
    DescAr: "",
    DescKu: "",

    ButtonEn: "",
    ButtonAr: "",
    ButtonKu: "",
  });

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);

  // Modal
  const [showModal, setShowModal] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);

  const resolveUrl = (u) => (u?.startsWith("http") ? u : `${API_BASE}${u}`);

  // ======================================================
  // LOAD (EN / AR / KU)
  // ======================================================
  useEffect(() => {
    const load = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VDPerfectBalanceSection?lang=en`),
          axios.get(`${API_BASE}/api/VDPerfectBalanceSection?lang=ar`),
          axios.get(`${API_BASE}/api/VDPerfectBalanceSection?lang=ku`),
        ]);

        setForm({
          TitleEn: en.data.title,
          TitleAr: ar.data.title,
          TitleKu: ku.data.title,

          DescEn: en.data.desc,
          DescAr: ar.data.desc,
          DescKu: ku.data.desc,

          ButtonEn: en.data.button,
          ButtonAr: ar.data.button,
          ButtonKu: ku.data.button,
        });

        setImage(en.data.image);

        setLoading(false);
      } catch (err) {
        console.error("LOAD FAILED:", err);
      }
    };

    load();
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // ======================================================
  // SAVE TEXT
  // ======================================================
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${API_BASE}/api/VDPerfectBalanceSection/16002`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Saved successfully!");
    } catch (err) {
      console.error("SAVE FAILED:", err);
      alert("Failed to save.");
    }
  };

  // ======================================================
  // UPLOAD IMAGE
  // ======================================================
  const handleUpload = async () => {
    if (!uploadFile) return alert("Select a file first.");

    const token = localStorage.getItem("token");
    const fd = new FormData();
    fd.append("Image", uploadFile);

    try {
      await axios.post(
        `${API_BASE}/api/VDPerfectBalanceSection/16002/media`,
        fd,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert("Image uploaded!");
      setShowModal(false);
      window.location.reload();
    } catch (err) {
      console.error("UPLOAD FAILED:", err);
      alert("Failed to upload image.");
    }
  };

  if (loading) return <p>Loading...</p>;

  // ======================================================
  // RENDER
  // ======================================================
  return (
    <div className="container py-4">

      <h2 className="fw-bold mb-4">VOYAH DREAM — Perfect Balance Editor</h2>

      {/* ================================
          TEXT INPUTS (EN / AR / KU)
      ================================ */}
      <div className="row">
        {LANGS.map((lang) => (
          <div key={lang} className="col-lg-4 col-md-6 mb-4">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body">
                <h5 className="text-primary">{lang}</h5>

                {/* TITLE */}
                <label className="form-label mt-3">Title</label>
                <textarea
                  className="form-control"
                  rows={2}
                  name={`Title${lang}`}
                  value={form[`Title${lang}`]}
                  onChange={handleChange}
                />

                {/* DESCRIPTION */}
                <label className="form-label mt-3">Description</label>
                <textarea
                  className="form-control"
                  rows={3}
                  name={`Desc${lang}`}
                  value={form[`Desc${lang}`]}
                  onChange={handleChange}
                />

                {/* BUTTON TEXT */}
                <label className="form-label mt-3">Button Text</label>
                <input
                  className="form-control"
                  name={`Button${lang}`}
                  value={form[`Button${lang}`]}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SAVE BUTTON */}
      <div className="text-end mb-5">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>

      {/* ================================
          IMAGE SECTION
      ================================ */}
      <h4 className="mb-3">Main Image</h4>

      <div className="card shadow-sm border-0 mb-5">
        <div className="card-body">
          {image ? (
            <img
              src={resolveUrl(image)}
              alt=""
              className="rounded w-100 mb-3"
              style={{ maxHeight: "300px", objectFit: "cover" }}
            />
          ) : (
            <p>No image uploaded.</p>
          )}

          <button
            className="btn btn-primary"
            onClick={() => {
              setUploadFile(null);
              setShowModal(true);
            }}
          >
            Upload / Replace
          </button>
        </div>
      </div>

      {/* MODAL */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Upload Image</h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  />
                </div>

                <div className="modal-body">
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-primary" onClick={handleUpload}>
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
};

export default VDPbEditor;
